import _extends from "@babel/runtime-corejs2/helpers/extends";
import * as React from 'react';
import FormGroup from '../decorators/FormGroup';
import Control from '../controls/Select';
import decorateControl from '../wrappers/decorateControl';
import FormField from '../wrappers/FormField';
// Just a quick'n dirty fix until we revamp that whole mess...
// Prevent the label/select inline "effect".
var Select = function Select(props) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Control, props));
};
var component = decorateControl(Select, FormGroup);
var SelectField = function SelectField(props) {
  return /*#__PURE__*/React.createElement(FormField, _extends({}, props, {
    component: component
  }));
};
export default SelectField;